/** Public Exxat Prism tutorials on YouTube. Copy is rewritten for the rail; titles do not use dash punctuation. */

export type SurveysOnboardingRailPhase = "setup" | "after"

export type SurveysOnboardingVideo = {
  id: string
  title: string
  coaching: string
}

export const SURVEYS_ONBOARDING_WELCOME_VIDEO_ID = "GX2POvR_J44"

const SETUP_VIDEOS: SurveysOnboardingVideo[] = [
  {
    id: "DUK535bfuuA",
    title: "Get the most from Surveys",
    coaching: "See where terms, surveys, and collection live before you finish setup.",
  },
  {
    id: "7F1NBDUXYUg",
    title: "Setting up courses",
    coaching: "Connect offerings so every evaluation has a course to attach to.",
  },
  {
    id: "iT1krbbZvYs",
    title: "Managing forms and evaluations",
    coaching: "Create the first survey. You can schedule it after this step.",
  },
]

const AFTER_VIDEOS: SurveysOnboardingVideo[] = [
  {
    id: SURVEYS_ONBOARDING_WELCOME_VIDEO_ID,
    title: "Managing learning activities",
    coaching: "See how collection runs after the term is live.",
  },
  {
    id: "iT1krbbZvYs",
    title: "Managing forms and evaluations",
    coaching: "Add another survey or change who is asked to respond.",
  },
  {
    id: "m4a6wuEbtb4",
    title: "Configuring custom reports",
    coaching: "Turn incoming responses into a report you can share with faculty.",
  },
]

export function surveysOnboardingRailHeading(phase: SurveysOnboardingRailPhase): string {
  return phase === "setup" ? "Walk through each step" : "Use what you set up"
}

export function surveysOnboardingVideos(phase: SurveysOnboardingRailPhase): SurveysOnboardingVideo[] {
  return phase === "setup" ? SETUP_VIDEOS : AFTER_VIDEOS
}

export function surveysOnboardingVideoEmbedUrl(videoId: string, autoplay = false): string {
  const params = new URLSearchParams({ rel: "0" })
  if (autoplay) params.set("autoplay", "1")
  return `https://www.youtube-nocookie.com/embed/${videoId}?${params.toString()}`
}

export function surveysOnboardingVideoPosterUrl(videoId: string, size: "hq" | "mq" = "hq"): string {
  const file = size === "mq" ? "mqdefault.jpg" : "hqdefault.jpg"
  return `https://img.youtube.com/vi/${videoId}/${file}`
}

export function surveysOnboardingWelcomeVideoEmbedUrl(): string {
  return surveysOnboardingVideoEmbedUrl(SURVEYS_ONBOARDING_WELCOME_VIDEO_ID)
}

export function surveysOnboardingWelcomeVideoPosterUrl(): string {
  return surveysOnboardingVideoPosterUrl(SURVEYS_ONBOARDING_WELCOME_VIDEO_ID)
}
